const SEARCH_GUEST_URL = '/guests/search';

export default{
  data(){
    return {
      needAutoSearch : true,
      selectedUsers: null,
      guests : [],
      headers : [{
        text : 'id'
      }, {
        text: 'first_name'
      }]
    }
  },
  methods: {
    setGuest(e){
      this.selectedUsers = e;
      this.guests = [];
      this.needAutoSearch = false;
    },
    search(){
      if(!this.needAutoSearch){
        setTimeout(() => {
          this.needAutoSearch = true
        }, 1000);
        return
      }
      let data = {};
      data.firstName = this.reservationInfo.firstName
      data.lastName = this.reservationInfo.lastName
      data.phone = this.reservationInfo.phone
      data.email = this.reservationInfo.email

      axios.post(SEARCH_GUEST_URL, data)
        .then(({data}) => {
          this.guests = _.map(data, (guest) => {
            guest.info = guest.first_name+' '+ guest.last_name +' '+guest.phone+' '+guest.email;
            return guest;
          })
        }).catch(e => {

      })
    }
  },
  watch:{
    selectedUsers(){
      this.reservationInfo.firstName = this.selectedUsers.first_name
      this.reservationInfo.lastName = this.selectedUsers.last_name
      this.reservationInfo.phone = this.selectedUsers.phone
      this.reservationInfo.email = this.selectedUsers.email
    },
    'reservationInfo.firstName': {
      handler() {
        this.debounced(() => {
          this.search();
        });
      }
    },
    'reservationInfo.lastName': {
      handler() {
        this.debounced(() => {
          this.search();
        });
      }
    },
    'reservationInfo.phone': {
      handler() {
        this.debounced(() => {
          this.search();
        });
      }
    },
    'reservationInfo.email': {
      handler() {
        this.debounced(() => {
          this.search();
        });
      }
    },
  }
}

